export default __webpack_public_path__ + "static/media/dancedance2.e1bf228e.gif";